var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',_vm._b({attrs:{"color":_vm.$randomColor(_vm.passenger.id)}},'v-avatar',_vm.$attrs,false),[_c('span',{staticClass:"white--text headline"},[_vm._v(_vm._s(_vm.passenger.avatarText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }